__turbopack_context__.v({
  "container": "_9GsX0a_container",
  "counter": "_9GsX0a_counter",
  "description": "_9GsX0a_description",
  "error": "_9GsX0a_error",
  "input": "_9GsX0a_input",
  "label": "_9GsX0a_label",
  "required": "_9GsX0a_required",
  "root": "_9GsX0a_root",
  "section": "_9GsX0a_section",
  "wrapper": "_9GsX0a_wrapper",
});
